import { useCustomMutation } from '../../../hooks/useCustomMutation';
import * as ENDPOINTS from './endpoints';

export const QUERY_KEYS = {
  ignorePrOrIssue: 'ignorePrOrIssue',
};

export const useIgnorePrOrIssue = () =>
  useCustomMutation([QUERY_KEYS.ignorePrOrIssue], ENDPOINTS.IgnorePrOrIssue);
